// extracted by mini-css-extract-plugin
export default {"vendorLogo":"vendorLogo__MmM4N","zolaLogo":"zolaLogo__MDMwZ"};